module.exports = __webpack_public_path__ + "img/2018_L.cc03bc61.png";